import $ from 'jquery';

// room slider
$(document).ready(function(){
    $('.carousel').slick({
        slidesToShow: 3,
        dots: true,
        centerMode: true,
    });
});
  